'use client';

import { ChevronRight } from 'lucide-react';
import type { BreadcrumbItem } from '../../types';

interface PageHeaderProps {
  title: string;
  description?: string;
  breadcrumbs?: BreadcrumbItem[];
  actions?: React.ReactNode;
}

export function PageHeader({
  title,
  description,
  breadcrumbs,
  actions,
}: PageHeaderProps) {
  return (
    <div className="mb-4 sm:mb-6">
      {/* 브레드크럼 - 모바일에서는 스크롤 가능 */}
      {breadcrumbs && breadcrumbs.length > 0 && (
        <nav className="flex items-center gap-1 text-xs sm:text-sm text-muted-foreground mb-2 overflow-x-auto whitespace-nowrap scrollbar-none">
          {breadcrumbs.map((item, index) => (
            <span key={index} className="flex items-center gap-1 shrink-0">
              {index > 0 && <ChevronRight className="w-3 h-3 sm:w-4 sm:h-4" />}
              {item.path ? (
                <button className="hover:text-foreground transition-colors">
                  {item.label}
                </button>
              ) : (
                <span className="text-foreground">{item.label}</span>
              )}
            </span>
          ))}
        </nav>
      )}

      {/* 제목 및 액션 - 모바일에서는 세로 배치 */}
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 sm:gap-4">
        <div className="min-w-0">
          <h1 className="text-xl sm:text-2xl font-bold text-foreground truncate">{title}</h1>
          {description && (
            <p className="text-sm text-muted-foreground mt-1 line-clamp-2">{description}</p>
          )}
        </div>
        {actions && (
          <div className="flex items-center gap-2 shrink-0">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
